/** Backblaze B2 folder for landing photos (allowed in next.config.js remotePatterns). */
const MEDIA = "https://f005.backblazeb2.com/file/marathon-el-salvador/landing/2026";

export const KV = {
  lettering: "/kv/kv-lettering.png",
  puerto: "/kv/kv-puerto.png",
  sunburst: "/kv/kv-sunburst.png",
  sunWaves: "/kv/kv-sun-waves.png",
  rueda: `${MEDIA}/rueda.png`,
  posterPortrait: "/kv/kv-poster-portrait.png",
  posterSquare: "/kv/kv-poster-square.png",
  poster45: "/kv/kv-poster-45.png",
  fsLogo: "/kv/kv-fs-logo.png",
  fsIcon: "/kv/kv-fs-icon.png",
};

export const PHOTOS = {
  himnoSalida: `${MEDIA}/himno-salida-1920.jpg`,
  llegadaMeta: `${MEDIA}/llegada-meta-1280.jpg`,
  corredorCelebrando: `${MEDIA}/corredor-celebrando-1080.jpg`,
  salidaNoche: `${MEDIA}/salida-noche-1080.jpg`,
};

export const EVENT = {
  name: "Maratón El Salvador",
  edition: "2027",
  /** Race-day start: the 42KM gun (El Salvador is UTC-6, no DST). */
  startsAt: "2027-02-14T04:30:00-06:00",
  startTime: "4:30 AM",
  dateShort: "14 FEB 2027",
  dateLong: "14 de febrero 2027",
  place: "Sunset Park (Puerto de La Libertad)",
  country: "El Salvador",
  organizer: "Fondistas Salvadoreños",
  email: "maratonelsalvador@gmail.com",
  instagram: "https://instagram.com/maraton.elsalvador_",
  facebook: "https://facebook.com/maratonelsalvador",
};

/** Start time per distance (km). Shown instead of the API's start_date times, which aren't kept up to date. */
export const START_TIMES: Record<number, string> = {
  42: "4:30 a. m.",
  21: "5:30 a. m.",
  10: "6:00 a. m.",
};

/** Start time for a distance like "21" or "42.195"; undefined if it isn't one of ours. */
export const startTimeFor = (distance: string | number): string | undefined =>
  START_TIMES[Math.floor(Number(distance))];

export const NAV_LINKS = [
  { label: "Inicio", href: "/" },
  { label: "Carreras", href: "/races" },
];

export interface ShowreelPhoto {
  src: string;
  alt: string;
  /** CSS object-position, tuned per photo so faces aren't cropped out. */
  focus?: string;
  /** Portrait photos get "contain" so they aren't zoomed into the 16:9 box. */
  fit?: "cover" | "contain";
}

const CAROUSEL = `${MEDIA}/carrousel`;

export const SHOWREEL_PHOTOS: ShowreelPhoto[] = [
  {
    src: `${CAROUSEL}/029_start_1771178682733662.JPG`,
    alt: "Corredores en el arco de salida de la Maratón El Salvador 2026",
    focus: "center 20%",
  },
  {
    src: `${CAROUSEL}/269_start_1771178702594877.JPG`,
    alt: "Corredores arrancando de noche bajo el arco de Garmin",
  },
  {
    src: `${CAROUSEL}/247_start_1771181082952997.JPG`,
    alt: "Corredor en la carretera al amanecer",
  },
  {
    src: `${CAROUSEL}/start_1771181060226110.JPG`,
    alt: "Corredora en la ruta junto a los campos al amanecer",
  },
  {
    src: `${CAROUSEL}/175_start_1771181038390429.JPG`,
    alt: "Corredor celebrando con los brazos en alto",
  },
  {
    src: `${CAROUSEL}/start_1771186165017548.JPG`,
    alt: "Corredor saludando a la banda que anima en la ruta",
  },
  {
    src: `${CAROUSEL}/start_1771187169627929.JPG`,
    alt: "Corredoras en el podio con sus trofeos",
    focus: "center 30%",
  },
];

